import styled, { createGlobalStyle } from 'styled-components';
import { variablesList } from 'constants/variablesList';
import { ThemeList } from 'store/ducks/globalTypes';
import { IThemeSelectorProps } from './ThemeSelector';

interface IProps {
  theme: ThemeList;
}

export const ThemeContainer = styled('div')<IThemeSelectorProps>`
  .ant-tabs .ant-tabs-nav .ant-tabs-tab {
    background-color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].defaultTabBg};
  }

  .ant-tabs-tab-active {
    background: ${(props) =>
      variablesList[props.theme as unknown as ThemeList]
        .tabSelected} !important;
  }

  .ant-btn.ant-btn-primary.ant-btn-icon-only:not(:disabled) {
    background-color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList]
        .iconButtonBg} !important;

    &:hover {
      background-color: ${(props) =>
        variablesList[props.theme as unknown as ThemeList]
          .iconButtonBgHover} !important;
    }
  }

  .ant-btn-icon-only {
    padding: 5px;
  }

  .ant-menu.ant-menu-root.ant-menu-horizontal {
    background-color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].menuBackground};
    border: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].menuBorder};
    color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].menuColor};

    li {
      span {
        span {
          color: ${(props) =>
            variablesList[props.theme as unknown as ThemeList].menuColor};
        }
      }
    }
  }

  .ant-menu-item:hover:not(.ant-menu-item-selected):not(
      .ant-menu-submenu-selected
    ),
  > .ant-menu
    .ant-menu-item:hover:not(.ant-menu-item-selected):not(
      .ant-menu-submenu-selected
    ) {
    color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].menuColorHover};
  }

  .ant-menu > .ant-menu-item-selected:before {
    background-color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].menuItemBg};
  }

  .ant-btn-primary:not(:disabled):hover {
    background-color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].buttonPrimaryBgHover};
  }

  .drag-text-box {
    border-bottom: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].colorBorder};
  }

  .ant-checkbox:not(.ant-checkbox-disabled) .ant-checkbox-inner {
    border: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].checkboxBorder};
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    border: 2px solid #aeaeae;
  }

  .ant-typography {
    color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].colorTypography};
  }

  .ant-table-tbody .ant-table-cell {
    // background-color: #ffcd0b4a;
    div,
    textarea,
    button {
      color: ${(props) =>
        variablesList[props.theme as unknown as ThemeList].tableCellColor};
    }
  }

  .editable-cell-value-wrap {
    border: 1px solid lightgrey;
    padding: 3px;
    border-radius: 8px;
  }
  .ant-picker-dropdown .ant-picker-today-btn {
    color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].datePickerDayColor};
  }

  .color-typography {
    color: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].colorTypography};
  }

  .ant-table-cell-row-hover {
    background: ${(props) =>
      variablesList[props.theme as unknown as ThemeList].bgColor} !important;
  }

  .nested-table-wrapper .ant-table-wrapper .ant-table {
    border-bottom: ${(props) =>
      variablesList[props.theme as unknown as ThemeList]
        .nestedTableBorder} !important;
  }

  .cln-req-wrapper .ant-table-wrapper .ant-table {
    .ant-table-tbody > tr:not(:first-child) > td {
      border-bottom: ${(props) =>
        variablesList[props.theme as unknown as ThemeList]
          .nestedTableBorder} !important;
    }
  }

  ${(props) =>
    props.theme === 'secondTheme' &&
    `
    .ant-table-thead .ant-table-cell,
    .ant-table-thead th,
    .ant-table-thead .ant-table-column-title,
    .ant-table-thead span {
      color: #374d6b !important;
    }
  `}

  ${(props) =>
    props.theme === 'fifthTheme' &&
    `
    .ant-table-thead .ant-table-cell,
    .ant-table-thead th,
    .ant-table-thead .ant-table-column-title,
    .ant-table-thead span {
      color: #374d6b !important;
    }
  `}
`;
